var MDB = window.MDB || {};;
MDB.Forms = MDB.Forms || {};
MDB.Forms.Settings = MDB.Forms.Settings || {};

$.extend(MDB.Forms.Settings,
    {
        _apiBaseUrl: '/api/dpo/Forms/Settings',
        _getUrlForVerb: function (verb) {
            return MDB.Forms.Settings._apiBaseUrl;
        },

        boot: function (model) {
            var grid = $('#settings-grid')
                , builder = MDB.KendoConfigBuilder
                , smlDropdownOpts = { ' ': ' ', 'S': 'S', 'M': 'M', 'L': 'L' }
                , smlDropdown = MDB.objectToDropdown(smlDropdownOpts);
        
            var ds = new kendo.data.DataSource({
                transport: {
                    read: function (opts) {
                        builder.dataSourceTransportFunction(MDB.Forms.Settings._getUrlForVerb('get'), 'GET', opts) 
                    },
                    update: function (opts) {
                        builder.dataSourceTransportFunction(MDB.Forms.Settings._getUrlForVerb('put'), 'PUT', opts) 
                    }
                },
                schema: {
                    model: {
                        id: 'KendoId',
                        fields: {
                            KendoId: { editable: false },
                            FormId: { editable: false },
                            GroupId: { editable: false },
                            QuestionId: { editable: false },

                            FormName: { editable: false },
                            Question: { editable: false },
                            SubQuestion: { editable: false },

                            SML: { editable: true },
                            LegallyObligated: { type: 'boolean', editable: true },
                            IsLegallyPreferred: { type: 'boolean', editable: true }
                        }
                    }
                },
                error: function (e) {
                    this.cancelChanges();
                    alert(builder.getWebApiErrorsMessage(e));
                },
                pageSize: 20,
                sort: {
                    field: 'FormName',
                    dir: 'asc'
                }
            });

            var gridConf = {
                dataSource: ds,
                columns: [{
                    field: 'FormName',
                    title: 'Form'
                }, {
                    field: 'Question',
                    title: 'Question'
                },
                {
                    field: 'SubQuestion',
                    title: 'SubQuestion'
                }, {
                    field: 'SML',
                    title: 'SML',
                    template: function (model) {
                        return smlDropdownOpts[model['SML']] || ' '; 
                    },
                    editor: function (container, opts) {
                        builder.gridDropdownEditor(container, opts.field, smlDropdown);
                    }
                }, {
                    field: 'LegallyObligated',
                    title: 'LegallyObligated',
                    template: builder.gridBooleanYesNoTemplate('LegallyObligated'),
                    editor: builder.gridCheckboxEditor,
                    filterable: false
                }, {
                    field: 'IsLegallyPreferred',
                    title: 'IsLegallyPreferred',
                    template: builder.gridBooleanYesNoTemplate('IsLegallyPreferred'),
                    editor: builder.gridCheckboxEditor,
                    filterable: false
                }],
                messages: {
                    commands: builder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: true,
                filterable: builder.gridGlobalFilterableSettings(),
                resizable: true,
                pageable: builder.gridPageableSettings()
            };

            if (model.editable) {
                gridConf.editable = {
                    mode: 'inline',
                    confirmation: false
                };

                gridConf.toolbar = ['create'];
                gridConf.columns.push(builder.gridCommandColumn(['edit']));
            }

            grid.kendoGrid(gridConf);
        }
    });